import * as FiIcons from 'react-icons/fi';

const {
  FiHome,
  FiSun,
  FiBriefcase,
  FiGrid,
  FiDroplet,
  FiWind,
  FiLayers,
  FiCompass,
  FiAward,
  FiClock,
  FiCheckCircle,
  FiMessageCircle
} = FiIcons;

export const services = [
  {
    icon: FiHome,
    title: 'Interior Residential Painting',
    description: 'Clean lines, flawless coverage, and a crew that respects your home — protected floors, tidy workspace, done right.'
  },
  {
    icon: FiSun,
    title: 'Exterior Residential Painting',
    description: 'Weather-ready finishes that protect your biggest investment and boost curb appeal for years to come.'
  },
  {
    icon: FiBriefcase,
    title: 'Commercial Interior & Exterior',
    description: 'Minimal disruption to your business, professional results, and a crew that works around your schedule.'
  },
  {
    icon: FiGrid,
    title: 'Kitchen Cabinet Resurfacing',
    description: 'NAPCO-certified refinishing for a new-kitchen look without the remodel price tag or timeline.'
  },
  {
    icon: FiDroplet,
    title: 'Bathtub Resurfacing',
    description: 'Restore your bathtub to like-new condition in days with NAPCO-certified techniques and materials.'
  },
  {
    icon: FiWind,
    title: 'Power Washing',
    description: 'Driveways, sidewalks, decks, and garage floors — professionally prepped and refreshed.'
  },
  {
    icon: FiLayers,
    title: 'Deck & Patio Finishing',
    description: 'Protect your outdoor space from Texas sun and weather with a professional stain or varnish finish.'
  },
  {
    icon: FiCompass,
    title: 'Color Consultation & Estimates',
    description: 'We help you choose the right color and provide a firm, honest price before work begins.'
  }
];

export const benefits = [
  {
    icon: FiAward,
    title: '20+ Years of Real Experience',
    description: "We've been doing this since 2008 — not learning on your dime."
  },
  {
    icon: FiClock,
    title: 'On Time, On Budget',
    description: 'The schedule and price you receive at the start are what you get at the end.'
  },
  {
    icon: FiCheckCircle,
    title: 'NAPCO-Certified Specialists',
    description: "Advanced resurfacing expertise most painting companies simply can't offer."
  },
  {
    icon: FiMessageCircle,
    title: 'Clear Communication',
    description: 'One point of contact, real answers, and no chasing us down for updates.'
  }
];

export const processSteps = [
  {
    title: 'Free Estimate',
    description: "We'll assess your space and provide a firm price — no guessing games."
  },
  {
    title: 'Schedule & Prep',
    description: 'We set a convenient start date and protect floors, furniture, and landscaping.'
  },
  {
    title: 'Expert Execution',
    description: 'Our crew uses premium materials and keeps you informed throughout the project.'
  },
  {
    title: 'Final Walkthrough',
    description: 'We inspect every detail with you to ensure it meets our standard — and yours.'
  }
];

export const testimonials = [
  {
    quote: 'Stay awesome! I was in a big hurry and in need of some painting. Cesar and his crew flew back into town and were literally at my house the next day!',
    author: 'Camille Acosta'
  },
  {
    quote: 'Very thorough, efficient, cordial, and professional. Excellent work! Highly recommend.',
    author: 'Warren Alfred'
  },
  {
    quote: 'The job was completed to my satisfaction. Cesar is fantastic.',
    author: 'Michael Sawyer'
  }
];

export const faqs = [
  {
    question: 'How fast can you get started?',
    answer: "In most cases we can schedule your free estimate within days, not weeks — reach out and we'll find a time that works."
  },
  {
    question: 'Do you provide free estimates?',
    answer: 'Yes. Every estimate is free, honest, and comes with no obligation to book.'
  },
  {
    question: 'What areas do you serve?',
    answer: 'We proudly serve Austin, Texas and the surrounding areas.'
  },
  {
    question: 'Are you licensed and insured?',
    answer: '[Confirm with client and insert accurate licensing and insurance details before launch.]'
  },
  {
    question: "What's included in cabinet and bathtub resurfacing?",
    answer: 'Our NAPCO-certified process restores cabinets, countertops, and bathtubs to a like-new finish at a fraction of the cost and time of full replacement.'
  },
  {
    question: 'How do you protect my home during the job?',
    answer: 'We cover and protect floors, furniture, and landscaping before work begins, and clean up thoroughly when we are done.'
  }
];

export const galleryImages = [
  {
    category: 'Interior',
    src: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1400&q=85',
    alt: 'Refined neutral living room interior'
  },
  {
    category: 'Exterior',
    src: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=85',
    alt: 'Modern upscale home exterior'
  },
  {
    category: 'Commercial',
    src: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1400&q=85',
    alt: 'Professionally finished commercial office'
  },
  {
    category: 'Resurfacing',
    src: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&w=1400&q=85',
    alt: 'Bright kitchen with refinished cabinetry'
  },
  {
    category: 'Interior',
    src: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1400&q=85',
    alt: 'Premium painted open-plan interior'
  },
  {
    category: 'Exterior',
    src: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1400&q=85',
    alt: 'Freshly painted contemporary home'
  }
];